import { Component, EventEmitter, Input, Output } from '@angular/core'
import { MatRadioChange } from '@angular/material/radio'
import { NGXLogger } from 'ngx-logger'
import { tabGroupLabels } from '../orders-dashboard.component'
import { Action, Store } from '@ngrx/store'
import { FilterActions } from '../../states/filter/filter.actions'

export interface FilterSelector {
  readonly type: FilterType
  readonly value: string
}

export enum FilterType {
  Date = 'Date',
  Status = 'Status',
  Type = 'Type',
}

@Component({
  selector: 'cover-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.scss'],
})
export class FilterComponent {
  constructor(private readonly logger: NGXLogger, private readonly store: Store) {}
  st = ''
  readonly FilterType = FilterType

  readonly date: Date = new Date()

  typeFilterValue = 'all'

  @Input() set setTypeFilter(value: string) {
    if (tabGroupLabels.includes(value.toLocaleLowerCase())) {
      this.typeFilterValue = value
    }
  }

  timeSpanValue = ''

  @Input() set setTimeSpan(value: string) {
    if (!value) {
      this.timeSpanValue = ''
    } else {
      this.timeSpanValue = value
    }
  }

  statusValue = ''

  @Input() set setStatus(value: string) {
    if (!value) {
      this.statusValue = ''
    } else {
      this.statusValue = value
    }
  }
  @Output() readonly closeSidenav: EventEmitter<void> = new EventEmitter<void>()
  @Output() readonly stateSelected: EventEmitter<FilterSelector> = new EventEmitter<FilterSelector>()
  onSelected(event: MatRadioChange, type: FilterType): void {
    let action: Action | undefined = void 0
    switch (type) {
      case FilterType.Type:
        action = FilterActions.changeTypeAction({ payload: event.value })
        break
      case FilterType.Date:
        action = FilterActions.changeDateAction({ payload: event.value })
        break
      case FilterType.Status:
        action = FilterActions.changeStatusAction({ payload: event.value })
        break
    }
    this.store.dispatch(action) // INFO: look heere
  }
}
